import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const sessionId = searchParams.get("sessionId");

    if (sessionId) {
      localStorage.setItem("sessionId", sessionId);
    }

    // Redirect to home page
    navigate("/");
  }, [navigate, searchParams]);

  // Return null since this is just a redirect component
  return null;
}
